import PropTypes from 'prop-types'

import Logo from '../Logo'

import './organizationCobrandingHeaderLogo.scss'

const OrganizationCobrandingHeaderLogo = ({
  includeEverplansLogo,
  organizationCobranding
}) => {
  if (!organizationCobranding) return null

  return (
    <div className='organization-cobranding-header-logo'>
      <img
        alt='organization logo'
        className='organization-logo'
        src={organizationCobranding.organizationLogoUrl}
      />
      <div className='powered-by-text-everplans-logo-container'>
        <div className='powered-by-text'>Powered by</div>
        {includeEverplansLogo && <a href='#/cm/dashboard'><Logo /></a>}
      </div>
    </div>
  )
}

OrganizationCobrandingHeaderLogo.propTypes = {
  includeEverplansLogo: PropTypes.bool,
  organizationCobranding: PropTypes.shape({
    organizationLogoUrl: PropTypes.string
  })
}

export default OrganizationCobrandingHeaderLogo
